
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    name: "modal-card",
    props: {
        className: {
            type: String,
            required: false,
            default: 'p-3 btn-secondary'
        },
        to: {
            type: String,
            required: true,
            default: ""
        }
    },
    setup() {
        const { t } = useI18n();

        return { t }
    }
});
